var SchemaTriggerType;
(function (SchemaTriggerType) {
    SchemaTriggerType[SchemaTriggerType["MANUAL"] = 0] = "MANUAL";
    SchemaTriggerType[SchemaTriggerType["ONCE"] = 1] = "ONCE";
    SchemaTriggerType[SchemaTriggerType["INTERVAL"] = 2] = "INTERVAL";
})(SchemaTriggerType || (SchemaTriggerType = {}));
export default SchemaTriggerType;
